import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import { Button, Col, ControlLabel, Form, FormControl, FormGroup, Glyphicon, Overlay, OverlayTrigger, Popover, Tooltip, } from 'react-bootstrap';
import DriverStatusCard from './DriverStatusCard';
import LoadingCircle from '../../ui/LoadingCircle';
import { ON_DUTY, OFF_DUTY } from '../../../constants/DriverStatus';
class DriverBar extends Component {
    constructor(props) {
        super(props);
        this.handleDriverToggled = (driver) => {
            const currentSelected = this.state.selected;
            let selected = null;
            let coords = null;
            if (currentSelected === driver.id) {
                selected = null;
                coords = this.props.market.center.coords;
            }
            else {
                selected = driver.id;
                coords = driver.coords;
            }
            this.setState({
                selected,
            });
            if (coords) {
                this.props.onDriverToggled(coords);
            }
        };
        this.handleClickNext = (e) => {
            e.preventDefault();
            const { currentPage, pages } = this.state;
            if (currentPage < pages) {
                this.setState({
                    currentPage: currentPage + 1,
                });
            }
        };
        this.handleClickPrev = (e) => {
            e.preventDefault();
            const { currentPage } = this.state;
            this.setState({
                currentPage: currentPage - 1,
            });
        };
        this.handleFiltersButtonMouseEnter = () => {
            this.setState({
                showFiltersTooltip: true,
            });
        };
        this.handleFiltersButtonMouseLeave = () => {
            this.setState({
                showFiltersTooltip: false,
            });
        };
        this.state = {
            currentPage: 1,
            pages: 1,
            pageSize: 20,
            selected: null,
            showFiltersTooltip: false,
        };
    }
    UNSAFE_componentWillReceiveProps(props) {
        if (typeof props.drivers !== 'undefined') {
            const drivers = props.drivers;
            const pageSize = this.state.pageSize;
            const pages = Math.ceil(drivers.length / pageSize);
            this.setState({
                pages,
            });
        }
        if (props.available !== this.props.available ||
            props.equipmentType !== this.props.equipmentType) {
            this.setState({
                currentPage: 1,
            });
        }
    }
    getVisibleDrivers() {
        const { currentPage, pageSize } = this.state;
        const begin = (currentPage - 1) * pageSize;
        const end = begin + pageSize;
        return this.props.drivers.slice(begin, end);
    }
    getStatus() {
        const available = this.props.available;
        switch (available) {
            case true:
                return ON_DUTY;
            case false:
                return OFF_DUTY;
            default:
                return '';
        }
    }
    getFiltersOverlay() {
        return (React.createElement(Popover, { id: "driver-filters-popover" },
            React.createElement(Form, { horizontal: true },
                this.renderStatusFilter(),
                this.renderEquipmentTypeFilter())));
    }
    addAddDriverTooltip() {
        const { t } = this.props;
        return React.createElement(Tooltip, { id: "add-driver-tooltip" }, t('ADD_DRIVER'));
    }
    hasPrev() {
        const { currentPage, pages } = this.state;
        return pages > 1 && currentPage > 1;
    }
    hasNext() {
        const { currentPage, pages } = this.state;
        return pages > 1 && currentPage < pages;
    }
    renderStatusFilter() {
        const status = this.getStatus();
        const { t } = this.props;
        return (React.createElement(FormGroup, { controlId: "driverStatus" },
            React.createElement(Col, { componentClass: ControlLabel, sm: 4 }, t('STATUS')),
            React.createElement(Col, { sm: 8 },
                React.createElement(FormControl, { componentClass: "select", value: status, onChange: (e) => this.props.onAvailabilityChange(e.target.value) },
                    React.createElement("option", { key: "any", value: "" }, t('ANY')),
                    React.createElement("option", { key: ON_DUTY, value: ON_DUTY }, t('ON_DUTY')),
                    React.createElement("option", { key: OFF_DUTY, value: OFF_DUTY }, t('OFF_DUTY'))))));
    }
    renderEquipmentTypeFilter() {
        const { t } = this.props;
        return (React.createElement(FormGroup, { controlId: "equipmentType" },
            React.createElement(Col, { componentClass: ControlLabel, sm: 4 }, t('EQUIPMENT_TYPE')),
            React.createElement(Col, { sm: 8 },
                React.createElement(FormControl, { componentClass: "select", value: this.props.equipmentType, onChange: (e) => this.props.onEquipmentTypeChange(e.target.value) },
                    React.createElement("option", { value: "" }, t('ANY')),
                    this.props.equipmentTypes.map((equipmentType) => (React.createElement("option", { key: equipmentType.label, value: equipmentType.label }, t(equipmentType.label))))))));
    }
    renderActionButtons() {
        const { t } = this.props;
        return (React.createElement("div", { className: "driver-filters" },
            React.createElement(OverlayTrigger, { placement: "bottom", trigger: ['click'], overlay: this.getFiltersOverlay() },
                React.createElement(Button, { title: t('FILTER', { count: 1 }), className: "btn-circle btn-circle-md", ref: (button) => {
                        this.filterButton = button;
                    }, onMouseEnter: this.handleFiltersButtonMouseEnter, onMouseLeave: this.handleFiltersButtonMouseLeave },
                    React.createElement(Glyphicon, { glyph: "filter" }))),
            React.createElement(Overlay, { show: this.state.showFiltersTooltip, container: this, placement: "bottom", target: () => this.filterButton },
                React.createElement(Tooltip, { id: "overload-left" }, t('FILTER_DRIVERS'))),
            React.createElement(OverlayTrigger, { placement: "bottom", overlay: this.addAddDriverTooltip() },
                React.createElement(Button, { className: "btn-circle btn-circle-md", onClick: () => this.props.onAddDriverButtonClick(), title: t('ADD_DRIVER') },
                    React.createElement(Glyphicon, { glyph: "plus" })))));
    }
    renderPrevButton() {
        const disabled = !this.hasPrev();
        return (React.createElement("div", { className: "driver-control" },
            React.createElement(Button, { block: true, className: "driver-control-btn", disabled: disabled, onClick: this.handleClickPrev },
                React.createElement(Glyphicon, { glyph: "chevron-left" }))));
    }
    renderNextButton() {
        const disabled = !this.hasNext();
        return (React.createElement("div", { className: "driver-control" },
            React.createElement(Button, { block: true, disabled: disabled, className: "driver-control-btn", onClick: this.handleClickNext },
                React.createElement(Glyphicon, { glyph: "chevron-right" }))));
    }
    renderLoadingIndicator() {
        const { loading, t } = this.props;
        if (!loading) {
            return null;
        }
        return (React.createElement("small", null,
            React.createElement(LoadingCircle, { text: `${t('LOADING_DRIVERS')}...`, size: 2 })));
    }
    renderEmptyState() {
        const { loading, drivers, t } = this.props;
        if (loading || drivers.length > 0) {
            return null;
        }
        return React.createElement("small", null,
            t('THERE_ARE_NO_DRIVERS'),
            "...");
    }
    renderLoadedState() {
        const visibleDrivers = this.getVisibleDrivers();
        return (React.createElement("div", { className: "driver-cards" }, visibleDrivers.map((driver) => {
            const selected = this.state.selected === driver._id;
            return (React.createElement(DriverStatusCard, { key: driver._id, driver: driver, selected: selected, onDriverCardClick: this.handleDriverToggled }));
        })));
    }
    renderDriverCards() {
        return (React.createElement("div", { className: "flex justify-center w-full pt-4" },
            this.renderPrevButton(),
            this.renderLoadingIndicator(),
            this.renderEmptyState(),
            this.renderLoadedState(),
            this.renderNextButton()));
    }
    render() {
        return (React.createElement("div", { className: "driver-bar bg-grey-light" },
            this.renderDriverCards(),
            this.renderActionButtons()));
    }
}
DriverBar.propTypes = {
    loading: PropTypes.bool,
    drivers: PropTypes.array,
    onDriverToggled: PropTypes.func.isRequired,
    onAddDriverButtonClick: PropTypes.func.isRequired,
    market: PropTypes.shape({
        code: PropTypes.string.isRequired,
        center: PropTypes.shape({
            coords: PropTypes.array,
        }).isRequired,
    }).isRequired,
    equipmentTypes: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired,
    })).isRequired,
    equipmentType: PropTypes.string,
    available: PropTypes.bool,
    onEquipmentTypeChange: PropTypes.func.isRequired,
    onAvailabilityChange: PropTypes.func.isRequired,
};
DriverBar.defaultProps = {
    loading: true,
    equipmentType: '',
    available: true,
    drivers: [],
};
export default withTranslation()(DriverBar);
